import React from 'react'
import MainMenuItem from 'src/components/Menu/MainMenuItem'
import { faQrcode } from '@fortawesome/pro-regular-svg-icons/faQrcode'
import { faQrcode as faQrcodeSolid } from '@fortawesome/pro-solid-svg-icons/faQrcode'
import { reverse } from 'src/routes/config'
import useTranslations from 'src/hooks/useTranslations'

export default function PlaybookMenu({ isOpen, parentIsCollapsed, onClick }) {
    const { t } = useTranslations('MainMenu', 'MainMenu')

    return (
        <MainMenuItem
            icon={faQrcode}
            iconActive={faQrcodeSolid}
            title={t('QR management')}
            isOpen={isOpen}
            onClick={onClick}
            parentIsCollapsed={parentIsCollapsed}
        >
            <MainMenuItem
                title={t('QR Codes')}
                to={reverse('playbook')}
                isActive={() => false}
            />
            <MainMenuItem
                title={t('QR Templates')}
                to={reverse('playbook')}
                isActive={() => false}
            />
        </MainMenuItem>
    )
}
